import React from 'react';
import Tooltip from '@dealroadshow/uikit/core/components/Tooltip';
import { Link } from '@/Framework/Router/Next/Link';
import { toSlug } from '@/Framework/url/helpers/toSlug';
import isServer from '@/Framework/Router/Next/isServer';

import spacesStyles from '@dealroadshow/uikit/core/styles/helpers/spaces.scss';
import styles from '@/finsight/ui/components/deals/DealsList/DealHeader/dealHeader.scss';

const LeadStructuring = ({
  structuringLeadsForAbbreviation,
  jointLeadsForAbbreviation,
  queryString,
}) => (
  structuringLeadsForAbbreviation && structuringLeadsForAbbreviation.map((lead, index) => (
    // eslint-disable-next-line react/no-array-index-key
    <span key={ index }>
      <Tooltip content={ `Structuring Lead: ${ lead.name }` }>
        <Link
          to={ {
              pathname: `/underwriter-${ lead.viewId }-${ toSlug(lead.name) }`,
              search: !isServer() ? window.location.search || queryString : '',
            } }
          className={ styles.link }
        >
          { lead.abbreviation }
        </Link>
      </Tooltip>
      { (index !== structuringLeadsForAbbreviation.length - 1 ||
        !!jointLeadsForAbbreviation.length) && (
        <span className={ spacesStyles.mrx }>,</span>
      ) }
    </span>
  )));

export default LeadStructuring;
